import React from 'react'
import OurPortfolioImg from '../../../Assets/images/shopify-img/our-portfolio-bg-color-img.jpg'
import { Image } from 'react-bootstrap'
import { isMobileOnly } from 'react-device-detect'

const OurPortfolio = () => {
  return (
    <>
 {isMobileOnly ?  <Image src={OurPortfolioImg} alt="shopify Logo image" className='img-fluid' style={{cursor: 'pointer'}}/>  : 
 
  <div className='bwn_our_portfolio_section'>

  </div>
    } 
    </>
  
    
  )
}

export default OurPortfolio